import { render, staticRenderFns } from "./MediaDialog.vue?vue&type=template&id=28411f84&scoped=true&"
import script from "./MediaDialog.vue?vue&type=script&lang=js&"
export * from "./MediaDialog.vue?vue&type=script&lang=js&"
import style0 from "./MediaDialog.vue?vue&type=style&index=0&id=28411f84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28411f84",
  null
  
)

export default component.exports